.overlay {
  position: absolute;
  inset: 0;
  z-index: 6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing\/2, 16px);
  background: var(--colors\/base\/black-alpha75, rgba(0, 0, 0, 0.75));
  backdrop-filter: blur(24px);
  color: var(--color\/text\/text-primary, #fff);
  padding: 48px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.visible {
  opacity: 1;
  pointer-events: auto;
}

.badge {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.message {
  max-width: 640px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--font\/fontsize\/body-large, 18px);
  margin: 0;
}

.title {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-large, 18px);
  font-weight: 600;
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  margin: 0;
}

.description {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-large, 18px);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  margin: 0;
}

.button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  border: none;
  border-radius: var(--radius\/xs, 2px);
  background: var(--color\/button\/blue-button-default, #3a6097);
  color: var(--color\/text\/text-primary, #fff);
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: 400;
  line-height: 1.7;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}

.button:hover {
  background: var(--color\/button\/blue-button-hover, #4d73ac);
}

.button:active {
  background: var(--color\/button\/blue-button-pressed, #3855a1);
}
